// src/components/Projects.js
import React from 'react';

const Projects = () => {
    return <div className="text-balance font-black font-sans">
    WIP. Come back soon!
  </div>;};

export default Projects;
